/* eslint-disable no-unused-vars */
import React from "react";
import couplesImg from "../../../../../assets/images/icon-couplesTherapy.svg";
import familyImg from "../../../../../assets/images/icon-familyTherapy.svg";
import groupImg from "../../../../../assets/images/icon-groupTherapy.svg";
import individualImg from "../../../../../assets/images/icon-individualTherapy.svg";
import assesmentImage from "../../../../../assets/icons/icon-assessment.svg";
import psychiatryImage from "../../../../../assets/icons/icon-psychiatry.svg";
import EditButton from "../../../../../containers/TherapistProfile/Tabs/EditButton";
import { BookAppointmentUniqueKeyEnum } from "src/latest/src/constants/BookAppointmentEnum";
import { Typography } from "src/latest/src/components";

interface Props {
    choices: any[];
    section: any;
    showPage: any;
    isParentTherapyProfilePage: boolean;
}

export const ServicesKeyValueContent2: React.FC<Props> = ({
    choices,
    section,
    showPage,
    isParentTherapyProfilePage,
}) => {
    if (!choices) return <></>;

    let serviceImage: string;
    let bgFill: string;

    const getImagePath = (
        path: BookAppointmentUniqueKeyEnum
    ): { serviceImage: string; bgFill: string } => {
        if (path === BookAppointmentUniqueKeyEnum.INDIVIDUAL_THERAPY) {
            serviceImage = individualImg;
            bgFill =
                "-webkit-linear-gradient(225deg, rgba(38,236,176,1) 0%, rgba(15,204,147,1) 100%), linear-gradient(225deg, rgba(233,158,249,1) 0%, rgba(174,83,228,1) 100%)";
        } else if (path === BookAppointmentUniqueKeyEnum.GROUP_THERAPY) {
            serviceImage = groupImg;
            bgFill =
                "-webkit-linear-gradient(225deg, rgba(233,158,249,1) 0%, rgba(174,83,228,1) 100%)";
        } else if (path === BookAppointmentUniqueKeyEnum.FAMILY_THERAPY) {
            serviceImage = familyImg;
            bgFill =
                "-webkit-linear-gradient(225deg, rgba(158,173,255,1) 0%, rgba(108,123,234,1) 100%)";
        } else if (path === BookAppointmentUniqueKeyEnum.COUPLES_THERAPY) {
            serviceImage = couplesImg;
            bgFill =
                "-webkit-linear-gradient(225deg, rgba(88,221,224,1) 0%, rgba(47,197,202,1) 100%)";
        } else if (path === BookAppointmentUniqueKeyEnum.ASSESMENT_THERAPY) {
            serviceImage = assesmentImage;
            bgFill =
                "-webkit-linear-gradient(225deg, #BDC2C8 0%, #929AA6 100%)";
        } else if (path === BookAppointmentUniqueKeyEnum.PSYCHIATRY_THERAPY) {
            serviceImage = psychiatryImage;
            bgFill =
                "-webkit-linear-gradient(225deg, #FF7C7C 0%, #FF426C 100%)";
        }

        return { serviceImage, bgFill };
    };

    return (
        <div className="d-flex practice-profile__services-wrap-outer therapist-profile__services-wrap-outer pb-24 ">
            {section && showPage && (
                <EditButton section={section} showPage={showPage} />
            )}
            {choices?.map((choice, j) => {
                if (choice.selected || isParentTherapyProfilePage) {
                    return (
                        <div
                            className="practice-profile__services-wrap-inner    therapist-profile__services-wrap-inner"
                            key={choice.unique_key + j}
                        >
                            <div
                                className=" practice-profile__image-wrap   therapist-profile__image-wrap me-2"
                                style={{
                                    backgroundImage: getImagePath(
                                        choice.unique_key
                                    ).bgFill,
                                }}
                            >
                                <img
                                    src={
                                        getImagePath(choice.unique_key)
                                            .serviceImage
                                    }
                                    alt={choice.title}
                                />
                            </div>
                            <Typography
                                variant={`size-12`}
                                weight={"regular"}
                                color="color-2"
                                className={`therapist-profile__value-first user-profile-content-prim `}
                            >
                                {choice?.title.includes("/")
                                    ? choice.title.split("/")[0]
                                    : choice.title}
                            </Typography>
                        </div>
                    );
                }

                return null;
            })}
        </div>
    );
};

export const ServicesContent2: React.FC<{
    section: any;
    isRemoveTitle: boolean;
    showPage: any;
}> = ({ section, isRemoveTitle, showPage }) => {
    const isPracticeProfilePage =
        window.location.pathname.includes("practice-profile");

    return (
        <>
            {section &&
                section?.questions?.map((question: any, index: any) => {
                    return (
                        <div
                            className="therapist-profile__main"
                            key={index}
                            style={
                                question.display_title ===
                                "Other Credentials & Certifications"
                                    ? { width: "100%" }
                                    : { width: "auto%" }
                            }
                        >
                            {!isRemoveTitle && (
                                <Typography
                                    variant="size-14"
                                    weight="bold"
                                    color="color-28"
                                    className="therapist-profile__title mb-1"
                                >
                                    {question.display_title}
                                </Typography>
                            )}
                            {
                                <ServicesKeyValueContent2
                                    choices={question.choices}
                                    section={section}
                                    showPage={showPage}
                                    isParentTherapyProfilePage={
                                        isPracticeProfilePage
                                    }
                                />
                            }
                        </div>
                    );
                })}
        </>
    );
};
